import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
} from "react-router-dom";
// import {createBrowserHistory} from 'history'
import { SinglePageLayout } from "../layouts/single-page-layout";
import { TrainingsControler } from "../components/trainings/trainings-ctrl";
import { HomeControler } from "../components/home/home-ctrl";
import { HomeTourControler } from "../components/home-tour/home-tour-ctrl";
//import { HomeIndexControler } from "../components/home-index/home-index-ctrl";
// **Login Pages**
import { Signin } from "../components/SignIn/Signin";
import { Signup } from "../components/SignIn/Signup";
import { Signupinvite } from "../components/SignIn/Signupinvite";
import { Signupreferral } from "../components/SignIn/Signupreferral";
import { Forgotpassword } from "../components/SignIn/Forgotpassword";
import { Resetpassword } from "../components/SignIn/Resetpassword";
// **Training Pages**
import { CourseDetailControler } from "../components/training-courses/course-detail-ctrl";
import { CourseOverviewControler } from "../components/training-courses/course-overview-ctrl";
import { CourseOverviewSingleControler } from "../components/training-courses/course-overview-single-ctrl";
import { MaturityDashboardPageController } from "../components/maturity-dashboard-page/maturity-dashboard-page-ctrl";

import { QuizController } from "../components/quiz/quiz-ctrl";
import { TrainingWalkthroughController } from "../components/training-walkthrough/training-walkthrough-ctrl";
// **Resources Pages**
import { Industry40Controller } from "../components/industry-40/industry-40-ctrl";
import { DigitalPlanController } from "../components/digital-plan/digital-plan-ctrl";
import { FrameworkController } from "../components/framework/framework-ctrl";
import { CpgstudyController } from "../components/cpgstudy/cpgstudy-ctrl";
// **Ticket Pages**
import { TicketsController } from "../components/tickets/tickets-ctrl";
// **Plans Page**
import { PlansPageController } from "../components/plans-page/plans-page-ctrl";
// **Profile Pages**
import { ProfileController } from "../components/profile/profile-ctrl";
import { PurchaseController } from "../components/profile/purchase-ctrl";
import { CertificateController } from "../components/profile/certificate-ctrl";
// **Cart Pages**
import { CartControler } from "../components/cart-page/cart-ctrl";
import { CartMatControler } from "../components/cartmaturity-page/cartmaturity-ctrl";
import { CartBillControler } from "../components/bill-page/bill-ctrl";
import { CartBillMaturityControler } from "../components/billmaturity-page/billmaturity-ctrl";
import { CartPaymentControler } from "../components/payment-page/payment-ctrl";
import { CartMatPaymentControler } from "../components/paymentmaturity-page/paymentmaturity-ctrl";
import { PaymentSuccessControler } from "../components/payment-success/payment-success-ctrl";
import { PaymentMatSuccessControler } from "../components/paymentmaturity-success/paymentmaturity-success-ctrl";
//LossAnalysis
import { LossAnalysisSetupPageController } from "../components/loss-analysis-setup-page/loss-analysis-setup-page-ctrl";
import { LossAnalysisSetupPagePlantController } from "../components/loss-analysis-setup-page/loss-analysis-setup-page-plant-ctrl";
import { LossAnalysisAdminPageController } from "../components/loss-analysis-admin-page/loss-analysis-admin-page-ctrl";
import { LossadminPlantController } from "../components/loss-analysis-admin-page/lossadmin-plant-ctrl";
import { LossanalysisQuesController } from "../components/la-questionnaires/la-questionnaires-ctrl";
import { LossanalysisPlantQuesController } from "../components/la-questionnaires/la-questionnaires-plant-ctrl";
import { LossAnalysisPagePlantController } from "../components/loss-analysis-page/loss-analysis-page-plant-ctrl";

// losssection
import { OperatorEffortController } from "../components/operator-effort-losses/operator-effort-ctrl";
import { OperatorEffortPlantController } from "../components/operator-effort-losses/operator-effort-plant-ctrl";
import { MaintenanceLossesPageController } from "../components/maintenance-losses/maintenance-losses-page-ctrl.js";
import { MaintenanceLossesPagePlantController } from "../components/maintenance-losses/maintenance-losses-page-plant-ctrl.js";
import { GeneralInformationPageController } from "../components/general-information/general-information-page-ctrl.js";
import { GeneralInformationPagePlantController } from "../components/general-information/general-information-page-plant-ctrl.js";
import { FteBreakdownPageController } from "../components/fte-breakdown/fte-breakdown-page-ctrl.js";
import { ManufacturingCostPageController } from "../components/manufacturing-cost/manufacturing-cost-page-ctrl.js";
import { ManufacturingCostPagePlantController } from "../components/manufacturing-cost/manufacturing-cost-page-plant-ctrl.js";
// **Assessment Pages**
import { AssessmentController } from "../components/assessment/assessment-ctrl";
import { AssessmentPlantController } from "../components/assessment/assessmentplant-ctrl";
import { ChapterController } from "../components/assessment/chapter-ctrl";
import { ChapterPlantController } from "../components/assessment/chapter-plant-ctrl";
import { AllquestionsController } from "../components/assessment/allquestions-ctrl";
import { AllquestionsPlantController } from "../components/assessment/allquestions-plant-ctrl";
import { QuestionsController } from "../components/assessment/question-ctrl";
import { QuestionsPlantController } from "../components/assessment/question-plant-ctrl";
// **Walkthrough Pages**
import { WalkthroughController } from "../components/walk-through/walkthrough-ctrl";
import { WalkthroughController1 } from "../components/assessment-walk-through/walkthrough1-ctrl";
import { ResulttourController } from "../components/resulttour/resulttour-ctrl";
// **Static Pages**
import { MaturityDashboardAdminController } from "../components/maturity-dashboard-admin/maturity-dashboard-admin-ctrl";
import { AdminWalkthroughController } from "../components/admin-walkthrough/admin-walkthrough-ctrl";
import { AllSectionsController } from "../components/all-sections/all-sections-ctrl";
import { ResultController } from "../components/result/result-ctrl";
import { ResultPlantController } from "../components/result/resultplant-ctrl";
import { ResultInviteController } from "../components/result/resultinvite-ctrl";
import { ResultWalkthroughController } from "../components/result-walkthrough/result-walkthrough-ctrl";
import { ViewResultWalkthroughController } from "../components/result-walkthrough/view-result-walkthrough-ctrl";
import { TrainingCourseWalkthrough } from "../components/course-overview-walkthrough/training-course-walkthrough";
import { QuizWalkthrough } from "../components/course-overview-walkthrough/quiz-walkthrough";
import { VerificationLinkSent } from "../components/SignIn/confirm-pass.js";
import { ThankYouEamilConfirm } from "../components/SignIn/thankYou-pass.js";
import { LossAnalysisTour } from "../components/loss-analysis-tour/loss-analysis-tour";
import { AllQuestionView } from "../components/assessment/all-qes-view.js";
import { PrepareHomeCtrl } from "../components/prepare-home-page/home-ctrl";

//business-case
import { BusinessCaseCtrl } from "../components/business-case/business-case-ctrl";
import { PowerBiLossAnalysisController } from "../components/powerbi-loss-analysis/powerbi-loss-analysis-ctrl";
import { ResultsPowerBiController } from "../components/results-power-bi/results-powerbi-ctrl";
import { PowerBiController } from "../components/power-bi/powerbi-ctrl";
import { LtExportController } from "../components/lt-export/lt-export-ctrl";
import { EducationController } from "../components/power-bi/education-ctrl";
import { PdController } from "../components/power-bi/pd-ctrl";
import { LosstrackController } from "../components/power-bi/losstrack-ctrl";
import { SkillController } from "../components/skill-assessment/skill-ctrl";
import { EadgeCaseView } from "../components/edge-case/EadgeCase";
import { SkillsAssessmentPageController } from "../components/skill-assessment/skills-assessment-page-ctrl";
import { Page404 } from "../components/page-404/page-404.js";
import Weblive from "../components/weblive";
import Roadmapconfigurator from "../components/roadmapconfigurator";

import { WhitePaperController } from '../components/white-paper/white-paper-ctrl';
import {LearningCenterController} from '../components/learning-resources-center-page/LearningCenterController';
import {LearningTrainingWalkthrough} from '../components/learning-resource-walkthrough/training-walkthrough-view.js' 
import {LearningAssessmentWalkthrough} from '../components/learning-resource-walkthrough/assessment-walkthrough.js' 
import {LearningAssessmentResultWalkthrough} from '../components/learning-resource-walkthrough/AssessmentResultWalkthrough.js' 
import {LearningLossAnalysisWalkthrough} from '../components/learning-resource-walkthrough/loss-analysis-walkthrough.js' 

// **End
export const Root = (props) => {
  const login = localStorage.getItem("isLoggedIn");
  const [isBrowserSupport, setIsBrowserSupport] = React.useState(true);
  const [ip, setIP] = React.useState();
  const citylist = [
    "Iraq",
    "Myanmar",
    "Zimbabwe",
    "Sudan",
    "Belarus",
    "North Korea ",
    "Lebanon",
    "Iran",
    "Somalia",
    "Guinea",
    "Libya",
    "Syria",
    "Guinea-Bissau",
    "Central African Republic",
    "Yemen",
    "Burundi",
    "South Sudan",
    "Mali",
    "Venezuela",
    "Nicaragua",
    "Democratic Republic of The Congo",
    "Ukraine",
    "Afghanistan",
  ];
  const getData = async () => {
    // const res = await axios.get('https://geolocation-db.com/json/')
    // const {data} = await axios.get('http://185.19.30.43/educatetraining/api/ipblock?param=ipblock')
    // console.log(data);
    // console.log(res.data.country);
    // setIP(res.data.country)
  };
  React.useEffect(() => {
    let userAgentString = window.navigator.userAgent;
    // Detect Internet Explorer
    let IExplorerAgent =
      userAgentString.indexOf("MSIE") > -1 ||
      userAgentString.indexOf("rv:") > -1;
    // Detect Firefox
    let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    if (IExplorerAgent || firefoxAgent) {
      setIsBrowserSupport(false);
    }
    getData();
  }, []);
  return (
    <>
      {/* {console.log(citylist.includes(ip)==false), console.log(ip) */}
      {citylist.includes("India") == false ? (
        <>
          {isBrowserSupport ? (
            <Router getUserConfirmation={() => {}}>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={HomeControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/home-tour"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={HomeTourControler}
                        {...props}
                      />
                    );
                  }}
                />
			<Route
                  exact
                  path="/analytics/education"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={EducationController}
                        {...props}
                      />
                    );
                  }}
                />
				<Route
                  exact
                  path="/projectdashboard/enterprise"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PdController}
                        {...props}
                      />
                    );
                  }}
                />
				<Route
                  exact
                  path="/analytics/losstrack"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LosstrackController}
                        {...props}
                      />
                    );
                  }}
                />
				
				
				<Route
                  exact
                  path="/skill-assessment/:id"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={SkillController}
                        {...props}
                      />
                    );
                  }}
                />
                 <Route
                  exact
                  path="/skill-assessment"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={SkillsAssessmentPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/quickstartopen"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={HomeControler}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Login Pages */}
                <Route path="/sign-in" component={Signin}></Route>
                <Route path="/sign-up" component={Signup}></Route>
				<Route
                  path="/weblivedata/:id"
                  component={Weblive}
                />
				<Route
                  path="/roadmapconfigurator/:id"
                  component={Roadmapconfigurator}
                />
                <Route
                  path="/weblivedata"
                  component={Weblive}
                />
                <Route
                  path="/forgot-password"
                  component={Forgotpassword}
                ></Route>
                <Route
                  path="/update-password/:id"
                  component={Resetpassword}
                ></Route>
                <Route
                  path="/sign-up-invite/:id"
                  component={Signupinvite}
                ></Route>
                <Route
                  path="/sign-up-referral/:id"
                  component={Signupreferral}
                ></Route>

                {/* Training Pages */}
                <Route
                  exact
                  path="/training-courses"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={TrainingsControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/training-courses/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={CourseOverviewControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/training-courses/:1/:2"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={CourseOverviewSingleControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/training-details/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={CourseDetailControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/training-quiz/:id"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={QuizController}
						quiz_page={true}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/training-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={TrainingWalkthroughController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Resources Pages */}
                <Route
                  exact
                  path="/framework"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={FrameworkController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/loss-analysis-admin"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress="true"
                        isSidebar="true"
                        children={LossAnalysisAdminPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/loss-analysis-admin/section/:slug"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={false}
                        isSidebar="true"
                        children={LossadminPlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/lossanalysisques"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar="true"
                        children={LossanalysisQuesController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/lossanalysisques/questionaire/:slug/:sec/:q"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={false}
                        isSidebar="true"
                        children={LossanalysisPlantQuesController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/lossanalysis/section/:slug"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={false}
                        isSidebar="true"
                        children={LossAnalysisPagePlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/loss-analysis-setup"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LossAnalysisSetupPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/operator-effort-losses/questionaire/:slug/:que"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={OperatorEffortPlantController}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/operator-effort-losses"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={OperatorEffortController}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/keyplant/:loasspages/questionaire/:slug/:que"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={MaintenanceLossesPagePlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/maintenance-losses"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={MaintenanceLossesPageController}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/general-information/questionaire/:slug/:sec/:q"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={GeneralInformationPagePlantController}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/general-information"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={GeneralInformationPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/fte-breakdown/questionaire/:slug/:sec/:q"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={FteBreakdownPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/manufacturing-cost/questionaire/:slug/:sec/:q"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={ManufacturingCostPagePlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/manufacturing-cost"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={false}
                        children={ManufacturingCostPageController}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/loss-analysis-setup/:slug"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LossAnalysisSetupPagePlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment/:slug"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={true}
                        children={AssessmentPlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/maturity-dashboard"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar="true"
                        children={MaturityDashboardPageController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/maturity-dashboard-admin"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={MaturityDashboardAdminController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/industry-40-dimensions"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={Industry40Controller}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/digital-plant"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={DigitalPlanController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/cpgstudy"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={CpgstudyController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Ticket Pages */}
                <Route
                  exact
                  path="/support-center"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={TicketsController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Plans Page */}
                <Route
                  exact
                  path="/plans"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PlansPageController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Profile Pages */}
                <Route
                  exact
                  path="/profile"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ProfileController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/purchase-history"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PurchaseController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/certificates"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={CertificateController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Cart Pages */}
                <Route
                  exact
                  path="/cart"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartControler}
                        {...props}
                      />
                    );
                  }}
                />
                {/* //update by educate */}

                <Route
                  exact
                  path="/cartmat:id"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartMatControler}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/billinginfo"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartBillControler}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/billingmaturity"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartBillMaturityControler}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/maturityasspayment"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartMatPaymentControler}
                        {...props}
                      />
                    );
                  }}
                />

                <Route
                  exact
                  path="/payment"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={CartPaymentControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/payment_success"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={PaymentSuccessControler}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/paymentmat_success"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={false}
                        children={PaymentMatSuccessControler}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Assessment Pages */}
                <Route
                  exact
                  path="/assessment"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={AssessmentController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment/chapter/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={ChapterController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment/questions/:slug/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={AllquestionsPlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment/questions/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={AllquestionsController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment/chapter/:slug/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={ChapterPlantController}
                        {...props}
                      />
                    );
                  }}
                />

                {/* //plant wise */}
                <Route
                  exact
                  path="/assessment/start/:slug/:1?/:2"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={QuestionsPlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessmentlim/start/:1?/:2"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isHeaderProgress={true}
                        isSidebar={true}
                        children={QuestionsController}
                        {...props}
                      />
                    );
                  }}
                />
                {/* Static Pages */}
                
                
                <Route
                  exact
                  path="/walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={WalkthroughController}
                        {...props}
                      />
                    );
                  }}
                />
                
                <Route
                  exact
                  path="/assessment-tour"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={WalkthroughController1}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/result-tour"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResulttourController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/assessment-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        isHeaderProgress={true}
                        children={AllSectionsController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/result/:plant"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResultPlantController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/result"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResultController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/view-result"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResultInviteController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/result-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResultWalkthroughController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/view-result-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ViewResultWalkthroughController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/course-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={TrainingCourseWalkthrough}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/quiz-walkthrough"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={QuizWalkthrough}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/email-sent"
                  render={(props) => {
                    return <VerificationLinkSent {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/email-sent"
                  render={(props) => {
                    return <VerificationLinkSent {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/email-confirmation/:id"
                  render={(props) => {
                    return <ThankYouEamilConfirm {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/loss-analysis-tour"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LossAnalysisTour}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/educate-prepare-home"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PrepareHomeCtrl}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/businesscase/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={BusinessCaseCtrl}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/losspowerbi"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PowerBiLossAnalysisController}
                        {...props}
                      />
                    );
                  }}
                />
				 <Route
                  exact
                  path="/learning-center"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LearningCenterController}
                        {...props}
                      />
                    );
                  }}
                />
				 <Route
                  exact
                  path="/whitepaper"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={WhitePaperController}
                        {...props}
                      />
                    );
                  }}
                />
				
				<Route 
                  exact 
                  path="/learning-training-walkthrough" 
                  render={(props) => { 
                    return ( 
                      <SinglePageLayout 
                        isSidebar="true" 
                        children={LearningTrainingWalkthrough} 
                        {...props} 
                      />
                    ); 
                  }} 
                />
				<Route 
                  exact 
                  path="/learning-assessment-walkthrough" 
                  render={(props) => { 
                    return ( 
                      <SinglePageLayout 
                        isSidebar="true" 
                        children={LearningAssessmentWalkthrough} 
                        {...props} 
                      />
                    ); 
                  }} 
                />
				
				<Route 
                  exact 
                  path="/learning-assessment-result-walkthrough" 
                  render={(props) => { 
                    return ( 
                      <SinglePageLayout 
                        isSidebar="true" 
                        children={LearningAssessmentResultWalkthrough} 
                        {...props} 
                      />
                    ); 
                  }} 
                />
				<Route 
                  exact 
                  path="/learning-loss-walkthrough" 
                  render={(props) => { 
                    return ( 
                      <SinglePageLayout 
                        isSidebar="true" 
                        children={LearningLossAnalysisWalkthrough} 
                        {...props} 
                      />
                    ); 
                  }} 
                />

                <Route
                  exact
                  path="/resultspowerbi"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={ResultsPowerBiController}
                        {...props}
                      />
                    );
                  }}
                />
				<Route
                  exact
                  path="/powerbi/:slug1/:slug2"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={PowerBiController}
                        {...props}
                      />
                    );
                  }}
                />
				
                <Route
                  exact
                  path="/ltexport/:1"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={LtExportController}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/not-found"
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar="true"
                        children={EadgeCaseView}
                        {...props}
                      />
                    );
                  }}
                />
                <Route
                  render={(props) => {
                    return (
                      <SinglePageLayout
                        isSidebar={true}
                        children={Page404}
                        {...props}
                      />
                    );
                  }}
                />
              </Switch>
            </Router>
          ) : (
            <BlockOnSomeBrowser />
          )}
        </>
      ) : (
        <BlockOnSomeCity />
      )}
    </>
  );
};

let BlockOnSomeBrowser = () => {
  return (
    <div className="block-on-blowsers-wrapper">
      <div className="block-on-logo">
        <img
          src={
            require("../assets/img/sidebar-img/team-header-logo.svg").default
          }
          alt="Samrterchains"
        />
      </div>
      <div className="block-on-text">
        <div className="p-wrapper">
          <p>Dear user,</p>

          <p>
            Please use one of the recommended web browsers (Chrome, Edge) to log
            into the platform.
          </p>
        </div>
      </div>
    </div>
  );
};

let BlockOnSomeCity = () => {
  return (
    <div className="block-on-blowsers-wrapper">
      <div className="block-on-logo">
        <img
          src={
            require("../assets/img/sidebar-img/team-header-logo.svg").default
          }
          alt="Samrterchains"
        />
      </div>
      <div className="block-on-text">
        <div className="p-wrapper">
          <p>Dear user,</p>

          <p>We are sorry. Our services are not available in your Country.</p>
        </div>
      </div>
    </div>
  );
};
